export default __webpack_public_path__ + "static/linkedin-f249b38224ca41a0b9098af151bcbb8b.png";